// TODO 7.15.0-B1 release of @enonic-types/core
// import type {Region} from '@enonic-types/core';
import {ComponentProps, LayoutData, Regions} from '@enonic/react-components';

import * as React from 'react';


export const LayoutDefault = ({component, meta, common}: ComponentProps<LayoutData>) => (
	<div className="container">
		<Regions data={component.regions} common={common} meta={meta} component={component}/>
	</div>
);
